import { useCallback } from 'react'
import {
  getLatestOepTargetFileJob,
  getOepTargetFileDownloadUrl,
  postGenerateOepTargetFile,
} from 'modules/annual-benefit-planning/modules/approval/infra/api/config.api'
import { APPROVAL_QUERY_KEYS } from 'modules/annual-benefit-planning/modules/approval/infra/react-query/approval.query-keys'
import {
  type GeneratedWorkbookJobsMessages,
  type GeneratedWorkbookJobsResult,
  useGeneratedWorkbookJobs,
} from './useGeneratedWorkbookJobs'

export { isInFlightJob } from './useGeneratedWorkbookJobs'

const TARGET_FILE_MESSAGES: GeneratedWorkbookJobsMessages = {
  loadFailure: 'Failed to load target file jobs.',
  generateFailure: 'Failed to generate target file. Please try again.',
  downloadFailure: 'Failed to download target file. Please try again.',
  generateFailureByStatus: {
    409: 'A target file job is already in progress for this client.',
  },
}

interface Options {
  readonly clientId: string
}

export function useOepTargetFileJobs({
  clientId,
}: Options): GeneratedWorkbookJobsResult {
  const fetchLatestJob = useCallback(
    () => getLatestOepTargetFileJob(clientId),
    [clientId]
  )
  const generateJob = useCallback(
    () => postGenerateOepTargetFile(clientId),
    [clientId]
  )
  const fetchDownloadUrl = useCallback(
    (jobId: string) => getOepTargetFileDownloadUrl(clientId, jobId),
    [clientId]
  )

  return useGeneratedWorkbookJobs({
    queryKey: APPROVAL_QUERY_KEYS.latestTargetFileJob(clientId),
    fetchLatestJob,
    generateJob,
    fetchDownloadUrl,
    messages: TARGET_FILE_MESSAGES,
  })
}
